/**
 * 附件的檢視旋轉角度(REQ-20260909004)—— 三組附件端點共用同一個值域。
 *
 * REQ-20260909001 在 lightbox 加了 ↺ / ↻,但角度只是元件內部 state,關掉重開就沒了。
 * 本次把角度存進資料庫,**但仍然不碰檔案本身**:MinIO 上的原圖與它的 EXIF 一個 byte
 * 都沒動(REQ-20260909001 §2.2 否決「轉檔重寫原圖」的理由不變 —— 附件是單據憑證,
 * 覆蓋原圖是不可逆的)。存的只是「看的時候要轉幾度」。
 *
 * 值域刻意收成四個字面量而不是 `z.number().int()` + 自訂 refine:
 * lightbox 的 `(r ± 90 + 360) % 360` 本來就只產生這四個值,寫成 union 之後
 * 型別上也只會是這四個 —— 呼叫端不必再想「37 度會怎樣」。
 */
import { z } from 'zod';

export const ATTACHMENT_ROTATIONS = [0, 90, 180, 270] as const;

export const AttachmentRotationSchema = z.union([
  z.literal(0),
  z.literal(90),
  z.literal(180),
  z.literal(270),
]);
export type AttachmentRotation = z.infer<typeof AttachmentRotationSchema>;

/** 三支 `PATCH .../rotation` 端點共用的 body */
export const SetAttachmentRotationSchema = z.object({
  rotation: AttachmentRotationSchema,
});
export type SetAttachmentRotationInput = z.infer<typeof SetAttachmentRotationSchema>;
